import React from "react";
import { motion } from "framer-motion";
import { Card, Button, Row, Col, Badge } from "react-bootstrap";
import { EnvelopeFill, GearFill } from "react-bootstrap-icons";

const SystemEmailSettings = () => {
  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.div
        className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        <motion.h5
          className="fw-semibold mb-3 text-primary"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          Email Settings
        </motion.h5>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-primary btn-sm"
        >
          + Add Fields
        </motion.button>
      </motion.div>

      {/* CARDS */}
      <div className="row g-3">
        {[
          {
            title: "PHP Mailer",
            desc: "Used to send emails safely via PHP code from a web server",
          },
          {
            title: "SMTP",
            desc: "SMTP is used to send, relay or forward messages from a mail client",
          },
        ].map((item, i) => (
          <div className="col-md-6" key={i}>
            <motion.div
              className="card shadow-sm border-0 h-100"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.1 }}
              whileHover={{ scale: 1.02 }}
            >
              <div className="card-body d-flex align-items-start gap-3">
                <div className="bg-light p-2 rounded d-flex align-items-center justify-content-center">
                  <EnvelopeFill size={22} />
                </div>

                <div className="flex-grow-1">
                  <h6 className="mb-1">{item.title}</h6>
                  <small className="text-muted">{item.desc}</small>

                  <div className="mt-2">
                    <Badge bg="success">Connected</Badge>
                  </div>
                </div>

                <GearFill className="text-muted" />
              </div>
            </motion.div>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <motion.div
        className="d-flex justify-content-end gap-2 mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-secondary"
        >
          Cancel
        </motion.button>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-success"
        >
          Save Changes
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default SystemEmailSettings;
